import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { AddmenuComponent } from './addmenu/addmenu.component';
import { AdminviewComponent } from './adminview/adminview.component';
import { CustomerComponent } from './customer/customer.component';
import { ForgetPassComponent } from './forget-pass/forget-pass.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { MenusComponent } from './menus/menus.component';
import { QrcodegenComponent } from './qrcodegen/qrcodegen.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent},
  { path: '',redirectTo: 'home' , pathMatch : 'full'},
  { path: 'login', component: LoginComponent },
  { path: 'addmenu', component: AddmenuComponent },
  { path: 'verify', component: LoginComponent},
  { path: 'qrcode', component: QrcodegenComponent },
  { path: 'menu-dashboard', component: MenusComponent},
  { path: 'about', component: AboutComponent},
  { path: 'adminView', component: AdminviewComponent},
  { path: 'forget-password', component: ForgetPassComponent},
{ path: '**', component: CustomerComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
